export default __webpack_public_path__ + "images/3ad81125aa9f45cd8905e41dada29470-do_11b.png";